import React, {useEffect, useState} from 'react';
import {Card, Col, ProgressBar, Row} from 'react-bootstrap';
import {FiInfo} from 'react-icons/fi';
import {IOfferOverviewCart} from './dto/IOfferOverviewCart';
import {numberFormatter} from '../../../../../utils/helpers/numberFormater';
import {useTranslation} from 'react-i18next';
import {percentageCalculate} from '../../../../../utils/helpers/percentageCalculate';
import {priceSplitter} from '../../../../../utils/helpers/priceSplitter';
import {IOffer} from '../../../../../model/offer/IOffer';
import {BookingAcceptOfferModal} from './BookingAcceptOfferModal';
import TooltipOverlay from '../../../../../shared/components/tooltip/Tooltip';
import {CampaignOffersDownloadButton} from '../../../../../shared/components/pdf/DownloadBulkOfferPdf';
import {useParams} from 'react-router-dom';
import {IParams} from '../../../../../model/shared/IParams';

interface IBookingOverviewCardProps {
    overviewCartInfo?: IOfferOverviewCart;
    bookSelectedOffer?: () => void;
    hasSentOffers?: boolean;
    offers?: IOffer[];
    hasPdf?: boolean;
    offerFilter?: string;
}

function BookingOverviewCard({
    offers,
    hasPdf,
    overviewCartInfo,
    bookSelectedOffer,
    hasSentOffers = false,
    offerFilter,
}: IBookingOverviewCardProps) {
    const { t } = useTranslation();
    const { id } = useParams<keyof IParams>();

    const [bookedValue, setBookedValue] = useState(0);
    const [plannedValue, setPlanedValue] = useState(0);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (overviewCartInfo?.selected?.budget === 0) {
            // setSelectedValue(0);
            setBookedValue(overviewCartInfo?.booked?.budget ?? 0);
            setPlanedValue(
                overviewCartInfo.plannedBudget - (overviewCartInfo?.booked?.budget + overviewCartInfo?.selected?.budget)
            );
        } else {
            setBookedValue(
                percentageCalculate(overviewCartInfo?.booked?.budget ?? 0, overviewCartInfo?.plannedBudget ?? 0)
            );
            if (overviewCartInfo?.selected?.budget ?? 0 > (overviewCartInfo?.booked?.budget ?? 0)) {
                // setSelectedValue(
                //     percentageCalculate(
                //         overviewCartInfo?.selected?.budget ?? 0 - (overviewCartInfo?.booked?.budget ?? 0),
                //         overviewCartInfo?.plannedBudget ?? 0
                //     )
                // );
            }
            setPlanedValue(0);
        }
    }, [overviewCartInfo]);

    // const openCheckoutPage = () => {
    //     navigate(`${InternalRoutes.BRAND_CAMPAIGN_BOOK}/${id}/checkout?hasSent=${hasSentOffers}`);
    // };

    return (
        <>
            <BookingAcceptOfferModal
                action={bookSelectedOffer}
                show={showModal}
                closeModal={() => setShowModal(false)}
                offers={offers}
            />
            <Card className="booking-card pb-5 pb-md-3 position-relative">
                <div className="overflow-auto p-3">
                    <h6>{t('brand.campaign.book.offer.overview_card.influencers_booked_selected')}</h6>
                    <div className="d-flex align-items-center">
                        <h6 className="text-success m-0"> {overviewCartInfo?.booked?.influencers} </h6>
                        {!!overviewCartInfo?.selected?.influencers && (
                            <>
                                <p className="mx-1 font-weight-bold">+</p>
                                <h6 className={`mb-0 text-primary`}> {overviewCartInfo?.selected?.influencers}</h6>
                            </>
                        )}
                    </div>
                    {!overviewCartInfo?.isCharity && (
                        <>
                            <div className="progress-sm progress-sm my-2">
                                <ProgressBar role="progressbar" className="progress-sm">
                                    <ProgressBar now={bookedValue} key={1} className="progress-sm" variant="success" />
                                    {/* <ProgressBar
                                        now={selectedValue}
                                        key={2}
                                        className="progress-sm"
                                        variant="primary"
                                    /> */}
                                    <ProgressBar
                                        now={plannedValue}
                                        key={3}
                                        className="progress-sm"
                                        variant="secondary"
                                    />
                                </ProgressBar>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div className="d-flex align-items-center">
                                    <h6 className="text-success euro-symbol">
                                        {overviewCartInfo?.isTransparentPricing
                                            ? priceSplitter(overviewCartInfo?.booked?.transparentBudget as number)
                                            : priceSplitter(overviewCartInfo?.booked?.budget as number)}
                                    </h6>
                                    {!!overviewCartInfo?.selected?.budget && (
                                        <>
                                            <h6 className="mx-1">+</h6>
                                            <h6 className={`text-primary euro-symbol`}>
                                                {' '}
                                                {overviewCartInfo?.isTransparentPricing
                                                    ? priceSplitter(
                                                          overviewCartInfo?.selected?.transparentBudget as number
                                                      )
                                                    : priceSplitter(overviewCartInfo?.selected?.budget as number)}
                                            </h6>
                                        </>
                                    )}
                                </div>
                                {overviewCartInfo?.isCharity ? (
                                    <p />
                                ) : (
                                    <p className="mb-0 text-muted euro-symbol">
                                        {' '}
                                        {priceSplitter(overviewCartInfo?.plannedBudget as number)}
                                    </p>
                                )}
                            </div>
                        </>
                    )}
                    <div className="my-2 text-muted d-flex justify-content-between mb-1">
                        <div className="d-flex">
                            <span className="d-flex align-items-center">
                                <span className="progress-label bg-success mr-1" />
                                {t('brand.campaign.book.offer.overview_card.booked')}
                            </span>
                            {/* <span className="d-flex align-items-center ml-2">
                                <span className={`progress-label mr-1 bg-primary`} />
                                {t('brand.campaign.book.offer.overview_card.selected')}
                            </span> */}
                        </div>
                        {!overviewCartInfo?.isCharity && (
                            <span className="text-muted">{t('brand.campaign.book.offer.overview_card.planned')}</span>
                        )}
                    </div>
                    <div className="border-bottom border-light my-3"></div>
                    <h6 className="my-2">{t('brand.campaign.book.offer.overview_card.summary')}</h6>
                    <Row className="justify-content-center">
                        <Col sm={6} className="my-2">
                            <div className="font-weight-bold d-flex align-items-center">
                                <h6 className="text-success m-0">
                                    {numberFormatter(overviewCartInfo?.booked?.followers ?? 0)}{' '}
                                </h6>
                                {!!Number(overviewCartInfo?.selected?.followers) && (
                                    <>
                                        <p className="mx-1">+</p>
                                        <h6 className={`mb-0 text-primary`}>
                                            {numberFormatter(overviewCartInfo?.selected?.followers ?? 0)}
                                        </h6>
                                    </>
                                )}
                            </div>
                            <p>{t('brand.campaign.book.offer.overview_card.followers')}</p>
                        </Col>
                        <Col sm={6} className="my-2">
                            <div className="font-weight-bold d-flex align-items-center">
                                <h6 className="text-success m-0">{overviewCartInfo?.booked?.contentUnits} </h6>
                                {!!Number(overviewCartInfo?.selected?.contentUnits) && (
                                    <>
                                        <p className="mx-1">+</p>
                                        <h6 className={`mb-0 text-primary`}>
                                            {overviewCartInfo?.selected?.contentUnits}
                                        </h6>
                                    </>
                                )}
                            </div>
                            <p className="d-flex align-items-center">
                                {t('brand.campaign.book.offer.overview_card.content_units')}
                                <TooltipOverlay
                                    className="ms-1"
                                    content={t(`brand.campaign.book.offer.overview_card.content_unitsTooltip`)}
                                >
                                    <FiInfo size={14} />
                                </TooltipOverlay>
                            </p>
                        </Col>
                        <Col sm={6} className="my-2">
                            <div className="font-weight-bold d-flex align-items-center">
                                <h6 className="text-success m-0">
                                    {numberFormatter(overviewCartInfo?.booked?.touchPoints ?? 0)}
                                </h6>

                                {!!overviewCartInfo?.selected?.touchPoints && (
                                    <>
                                        <p className="mx-1">+</p>
                                        <h6 className={`mb-0 text-primary`}>
                                            {numberFormatter(overviewCartInfo?.selected?.touchPoints ?? 0)}
                                        </h6>
                                    </>
                                )}
                            </div>
                            <p className="d-flex align-items-center">
                                {t('brand.campaign.book.offer.overview_card.touchpoints')}
                                <TooltipOverlay
                                    className="ms-1"
                                    content={t(`brand.campaign.book.offer.overview_card.touchpointsTooltip`)}
                                >
                                    <FiInfo size={14} />
                                </TooltipOverlay>
                            </p>
                        </Col>
                        <Col sm={6} className="my-2">
                            <div className="font-weight-bold d-flex align-items-center">
                                <h6 className="text-success m-0">
                                    {priceSplitter(overviewCartInfo?.booked?.totalER)}%{' '}
                                </h6>
                            </div>
                            <p className="d-flex align-items-center">
                                {t('brand.campaign.book.offer.overview_card.engagement_rate')}
                                <TooltipOverlay
                                    className="ms-1"
                                    content={t(`brand.campaign.book.offer.overview_card.engagement_rateTooltip`)}
                                >
                                    <FiInfo size={14} />
                                </TooltipOverlay>
                            </p>
                        </Col>
                    </Row>

                    {/*<BookingOverviewAccordion*/}
                    {/*  isAccordionOpened={isAccordionOpened}*/}
                    {/*  setIsAccordionOpened={setIsAccordionOpened}*/}
                    {/*  bookedPlatforms={overviewCartInfo?.booked?.platformSum}*/}
                    {/*  selectedPlatforms={overviewCartInfo?.selected?.platformSum}*/}
                    {/*/>*/}
                </div>
                <div className="px-3">
                    {!overviewCartInfo?.isCharity && (
                        <>
                            {/* <div className="d-flex justify-content-between">
                                <h5>{t('brand.campaign.book.offer.overview_card.selected_price')}</h5>
                                <h5 className={`text-primary euro-symbol`}>
                                    {overviewCartInfo?.isTransparentPricing
                                        ? priceSplitter(overviewCartInfo?.selected?.transparentBudget as number)
                                        : priceSplitter(overviewCartInfo?.selected?.budget as number)}
                                </h5>
                            </div> */}
                            <div className="d-flex justify-content-between">
                                <h5 className="mb-0">{t('brand.campaign.book.offer.overview_card.total_price')}</h5>
                                <h5 className="mb-0 text-success euro-symbol">
                                    {overviewCartInfo?.isTransparentPricing
                                        ? priceSplitter(
                                              (overviewCartInfo?.selected?.transparentBudget ?? 0) +
                                                  (overviewCartInfo?.booked?.transparentBudget ?? 0)
                                          )
                                        : priceSplitter(
                                              (overviewCartInfo?.selected?.budget ?? 0) +
                                                  (overviewCartInfo?.booked?.budget ?? 0)
                                          )}
                                </h5>
                            </div>
                        </>
                    )}
                    {/* <Button
                        className="w-100"
                        disabled={(checkout && (overviewCartInfo?.selected?.influencers ?? 0)) === 0 && true}
                        onClick={checkout ? () => setShowModal(true) : openCheckoutPage}
                    >
                        {checkout
                            ? t('general.confirm_selection')
                            : (overviewCartInfo?.selected?.influencers ?? 0) > 0
                            ? t('brand.campaign.book.offer.overview_card.proceed')
                            : t('brand.campaign.book.offer.overview_card.booked_offers')}
                    </Button> */}
                    {/*{offerFilter === 'booked' && hasPdf && (*/}
                    {/*    <HtmlToPdf styleContent="mt-4 w-100" styleBtn="btn-outline-primary" />*/}
                    {/*)}*/}
                    {offerFilter === 'booked' && hasPdf && <CampaignOffersDownloadButton campaignId={id ? Number(id): undefined}/>}
                </div>
            </Card>
        </>
    );
}

export default BookingOverviewCard;
